import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { actualizaAlert, actualizaFilter } from '../../Slicersreducers';
import { CardBody, Row, CardTitle } from 'reactstrap';
export const ProductFilter = ({
  product,
  movements,
  handleMovements,
  deleteTimeAlert,
}) => {
  const dispatch = useDispatch();
  const listProductsHome = useSelector((state) => state.miga.listProductsHome);
  const [DataFilter, setDataFilter] = useState([]);
  const [datosCuenta, setDatosCuenta] = useState({
    nombreCuenta: '',
    numeroCuenta: '',
  });

  const handleChangeNombreCuenta = (e) => {
    setDatosCuenta((prevState) => ({
      ...prevState,
      nombreCuenta: e.target.value,
    }));
  };

  const handleChangeNumeroCuenta = (e) => {
    setDatosCuenta((prevState) => ({
      ...prevState,
      numeroCuenta: e.target.value,
    }));
  };

  const handleApplyFilter = () => {
    let filtereDescription = [];
    let filterAccountNumber = [];
    let listFilterProducts = [];
    if (datosCuenta.nombreCuenta != '') {
      filtereDescription = movements.filter((movement) =>
        movement.description.includes(datosCuenta.nombreCuenta)
      );
    }

    if (datosCuenta.numeroCuenta != '') {
      filterAccountNumber = movements.filter((movement) =>
        movement.accountNumber.includes(datosCuenta.numeroCuenta)
      );
    }

    if (filtereDescription.length > 0) {
      if (filterAccountNumber.length > 0) {
        listFilterProducts = filtereDescription.concat(filterAccountNumber);
      } else {
        listFilterProducts = filtereDescription;
      }
    } else if (filterAccountNumber.length > 0) {
      listFilterProducts = filterAccountNumber;
    } else {
      const dataAlert = [
        {
          description:
            'El criterio de búsqueda no coincide con la información de los productos.',
          type: 'alert alert-alert show alert-dismissible fade alert-danger',
          icon: 'fas fa-exclamation-circle',
        },
      ];

      dispatch(actualizaAlert(dataAlert));
      deleteTimeAlert();
    }
    setDataFilter(listFilterProducts);
  };

  const closeFilter = (i) => {
    dispatch(actualizaFilter([false, false, false]));
  };

  useEffect(() => {
    if (DataFilter.length != 0) {
      handleMovements(DataFilter);
    }
  }, [DataFilter]);

  return (
    <>
      {product.toLowerCase().includes('convenios') && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            padding: '20px',
          }}
        >
          <div
            style={{
              display: 'flex',
              width: '100%',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              cursor: 'default',
              padding: '2px',
            }}
          >
            <CardTitle
              tag="h4"
              className="text-uppercase mb-1 font-weight-bold text-green"
              style={{ paddingBottom: '20px' }}
            >
              {product}
            </CardTitle>
            <div
              tag="h4"
              className="text-uppercase mb-1 font-weight-bold text-green"
              style={{ paddingBottom: '20px', cursor: 'pointer' }}
              onClick={closeFilter}
            >
              X
            </div>
          </div>
          <input
            style={{ display: 'flex', width: '90%', borderRadius: '4px' }}
            placeholder="Nombre de la Cuenta"
            type="text"
            value={datosCuenta.nombreCuenta}
            onChange={handleChangeNombreCuenta}
          />
          <input
            style={{ display: 'flex', width: '90%', borderRadius: '4px' }}
            placeholder="Número de la Cuenta"
            type="text"
            value={datosCuenta.numeroCuenta}
            onChange={handleChangeNumeroCuenta}
          />
          <button
            className="btn btn-success"
            onClick={handleApplyFilter}
            style={{ marginBottom: '1em' }}
          >
            Aplicar
          </button>
        </div>
      )}

      {product.toLowerCase().includes('préstamos') && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            padding: '20px',
          }}
        >
          <div
            style={{
              display: 'flex',
              width: '100%',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '2px',
              cursor: 'default',
            }}
          >
            <CardTitle
              tag="h4"
              className="text-uppercase mb-1 font-weight-bold text-green"
              style={{ paddingBottom: '20px' }}
            >
              {product}
            </CardTitle>
            <div
              tag="h4"
              className="text-uppercase mb-1 font-weight-bold text-green"
              style={{ paddingBottom: '20px', cursor: 'pointer' }}
              onClick={closeFilter}
            >
              X
            </div>
          </div>
          <input
            style={{ display: 'flex', width: '90%', borderRadius: '4px' }}
            placeholder="Número de Prestamo"
            type="text"
            onChange={handleChangeNumeroCuenta}
          />

          <button
            className="btn btn-success"
            onClick={handleApplyFilter}
            style={{ margin: '1em' }}
          >
            {' '}
            Aplicar
          </button>
        </div>
      )}

      {product.toLowerCase().includes('cdats') && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            padding: '20px',
          }}
        >
          <div
            style={{
              display: 'flex',
              width: '100%',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '2px',
              cursor: 'default',
            }}
          >
            <CardTitle
              tag="h4"
              className="text-uppercase mb-1 font-weight-bold text-green"
              style={{ paddingBottom: '20px' }}
            >
              {product}
            </CardTitle>
            <div
              tag="h4"
              className="text-uppercase mb-1 font-weight-bold text-green"
              style={{ paddingBottom: '20px', cursor: 'pointer' }}
              onClick={closeFilter}
            >
              X
            </div>
          </div>
          <input
            style={{ display: 'flex', width: '90%', borderRadius: '4px' }}
            placeholder="Numero de CDAT"
            type="text"
            onChange={handleChangeNumeroCuenta}
          />
          <button
            className="btn btn-success"
            onClick={handleApplyFilter}
            style={{ margin: '1em' }}
          >
            {' '}
            Aplicar
          </button>
        </div>
      )}
    </>
  );
};
